export default {
    "resultSelector": {
        "selectDocument": "Select document",
        "unselectDocument": "Unselect document"
    },
    "resultsSelector": {
        "selectDocuments": "{count, selectordinal, =0 {} other {(#)}}",
        "selectDocumentsTitle": "Select documents",
        "unselectDocumentsTitle": "Unselect documents"
    },
    "selection": {
        "selectedDocuments": "{count, plural, =0 {} one {# selected document} other {# selected documents}}"
    }
};
